export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'NL',
  'merchantReturnLink': 'https://www.timberland.nl/nl-nl/klantenservice/retour-instructies',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
